module.exports = __webpack_public_path__ + "static/media/health_ins.d083d36d.png";